export default __webpack_public_path__ + "static/media/torajaa.d3c0b0fc.jpg";